import { SelectOption } from '@/shared/types';
import { Select, Modal, Button, Icon, ButtonVariant, useModal } from '@/shared/ui';

import { WeaponMode, WeaponType } from '@/api/types';

export interface WeaponFiltersProps {
  filterStatusOptions: Array<SelectOption<NonNullable<WeaponFiltersProps['selectedStatus']>>>;
  filterTypeOptions: Array<SelectOption<NonNullable<WeaponFiltersProps['selectedType']>>>;
  selectedStatus: Nullable<WeaponMode>;
  selectedType: Nullable<WeaponType>;
  setSelectedStatus: (state: Nullable<WeaponMode>) => void;
  setSelectedType: (state: Nullable<WeaponType>) => void;
  resetFilters: () => void;
}

const Filters: React.FC<WeaponFiltersProps> = ({
  filterStatusOptions,
  filterTypeOptions,
  selectedStatus,
  selectedType,
  setSelectedStatus,
  setSelectedType,
}) => {
  return (
    <div className="weapon-registered__filters">
      <Select
        label="Статус"
        allowClear
        options={filterStatusOptions}
        value={selectedStatus}
        onChange={setSelectedStatus}
      />
      <Select
        label="Тип зброї"
        allowClear
        options={filterTypeOptions}
        value={selectedType}
        onChange={setSelectedType}
      />
    </div>
  );
};

export const WeaponFilters: React.FC<WeaponFiltersProps> = (props) => {
  const { resetFilters } = props;

  const { isOpen, toggleModal } = useModal();

  return (
    <>
      <aside className="weapon-registered__desktop-filters">
        <Filters {...props} />
      </aside>
      <div className="weapon-registered__mobile-filters">
        <Button variant={ButtonVariant.SECONDARY} onClick={(): void => toggleModal()}>
          <Icon name="filter_list" />
          Фільтрація
        </Button>
      </div>
      <Modal
        title="Фільтрація"
        open={isOpen}
        onCancel={(): void => toggleModal()}
        footer={
          <>
            <Button onClick={(): void => toggleModal()}>Шукати</Button>
            <Button onClick={resetFilters} variant={ButtonVariant.SECONDARY}>
              <Icon name="clear_all" />
              Очистити
            </Button>
          </>
        }
        classNames={{ footer: 'weapon-filter__footer', content: 'weapon-filter', body: 'weapon-filter__body' }}
      >
        <Filters {...props} />
      </Modal>
    </>
  );
};
